
import { combineReducers,Reducer } from 'redux';
import authReducer from "./reducers/slices/authSlice";

 import auth, { AuthState } from './reducers/slices/authSlice';

interface RootState {
   auth: AuthState;

}

const rootReducer = combineReducers({
   auth: authReducer,
  
});

export default rootReducer;
export type { RootState };
